import React from 'react';
import SectionForm from "../SectionForm";
import {capitaliseFirst} from "../../../../../../assets/scripts/string-functions";
import {PersonalAccommodationSituations} from "../../../../../../models";
export function negativeCredit(props) {
	return {
		name: "negativeCredit",
		answer: {
			type: "choice",
			choices: [
				{
					text: "Yes",
					value: true
				},
				{
					text: "No",
					value: false
				}
			]
		},
		label: "Negative Credit",
		text: capitaliseFirst(props.you.haveYou) + " ever been made bankrupt, made any arrangements with creditors, had any court judgements for debt made against you or been in arrears with any existing or previous loan?",
		model: "financial",
		target: `applicant${props.applicant}.financial.negativeCredit`,
		rules: [
			{required: true, message: `An answer is required`},
		]
	}
}
export function contributeToRelatives(props) {
	return {
		text: capitaliseFirst(props.you.doYou) + " contribute anything towards " + props.you.your + " upkeep there?",
		label: "Boarding Contribution",
		name: "contributeToRelatives",
		answer: {
			type: "choice",
			choices: [
				{
					text: "Yes",
					value: true
				},
				{
					text: "No",
					value: false
				}
			]
		},
		hides: (form) => {
			return form.getFieldValue('accommodationSituation') !== "RELATIVES"
		},
		model: "financial",
		target: `applicant${props.applicant}.financial.contributeToRelatives`,
		rules: [
			{required: true, message: `An answer is required`},
		]
	}
}
export function monthlyAccommodationCosts(props) {
	return {
		name: "monthlyAccommodationCosts",
		label: "Accommodation Costs",
		text: (form) => {
			let value = form.getFieldValue('accommodationSituation')
			if (value === PersonalAccommodationSituations.RENTED) {
				return "How much is " + props.you.your + " rent per month?"
			}
			return "How much is " + props.you.your + " contribution per month?"
		},
		answer: {
			type: "euro",
			validation: {
				min: {value: 1, message: "This must be a value greater than €1"},
				max: {value: 10000000, message: "You probably don't need a mortgage"}
			}
		},
		// hides: (form) => {
		// 	let value = form.getFieldValue('accommodationSituation')
		// 	if (value === PersonalAccommodationSituations.RELATIVES) {
		// 		if (form.getFieldValue('contributeToRelatives')) {
		// 			return false
		// 		}
		// 	}
		// 	return value !== PersonalAccommodationSituations.RENTED
		// },
		model: "financial",
		target: `applicant${props.applicant}.financial.monthlyAccommodationCosts`,
		rules: [
			{required: true, message: `An accommodation cost is required`},
			{type: 'number', min: 1, message: 'This must be a value greater than zero'},
			{type: 'number', max: 10000, message: 'Maximum accommodation costs are €10,000'}
		]
	}
}
export function hasChildcareCosts(props) {

	return {
		label: "Has Child Minding Costs",
		text: capitaliseFirst(props.you.doYou) + " have any child-minding costs?",
		name: "hasChildcareCosts",
		answer: {
			type: "choice",
			choices: [
				{
					text: "Yes",
					value: true
				},
				{
					text: "No",
					value: false
				}
			]
		},
		hides: (form) => {
			let value = form.getFieldValue('countDependents')
			return parseInt(value) === 0
		},
		model: "financial",
		target: `applicant${props.applicant}.financial.hasChildcareCosts`,
		rules: [
			{required: true, message: `An answer is required`},
		]
	}
}
export function monthlyChildcareCosts(props) {
	return {
		label: "Child Minding Costs",
		text: "How much are " + props.you.your + " child-minding costs per month?",
		name: "monthlyChildcareCosts",
		answer: {
			type: "euro",
			validation: {
				min: {value: 1, message: "This must be a value greater than €1"},
				max: {value: 10000000, message: "You probably don't need a mortgage"}
			}
		},
		hides: (form) => {
			let count = form.getFieldValue('countDependents')
			if (parseInt(count) === 0) {
				return true
			}
			let costs = form.getFieldValue('hasChildcareCosts')
			return !costs
		},
		model: "financial",
		target: `applicant${props.applicant}.financial.monthlyChildcareCosts`,
		rules: [
			{required: true, message: `An amount is required`},
		]
	}
}
export function hasSavings(props) {
	return {
		label: "Has Savings",
		text: capitaliseFirst(props.you.doYou) + " have any savings?",
		name: "hasSavings",
		answer: {
			type: "choice",
			choices: [
				{
					text: "Yes",
					value: true
				},
				{
					text: "No",
					value: false
				}
			]
		},
		model: "financial",
		target: `applicant${props.applicant}.financial.hasSavings`,
		rules: [
			{required: true, message: `An answer is required`},
		]
	}
}
export function monthlySavings(props) {
	return {
		label: "Monthly Savings",
		text: "How much do ESTIMATE " + props.you.you + " save each month?",
		name: "monthlySavings",
		answer: {
			type: "euro",
			validation: {
				min: {value: 1, message: "This must be a value greater than €1"},
				max: {value: 10000000, message: "You probably don't need a mortgage"}
			}
		},
		model: "financial",
		target: `applicant${props.applicant}.financial.monthlySavings`,
		rules: [
			{required: true, message: `An amount is required`},
		]
	}
}
export function hasCurrentAccountSavings(props) {
	return {
		label: "Has Current Account Savings",
		text: capitaliseFirst(props.you.doYou) + " have any savings in your current account?",
		name: "hasCurrentAccountSavings",
		answer: {
			type: "choice",
			choices: [
				{
					text: "Yes",
					value: true
				},
				{
					text: "No",
					value: false
				}
			]
		},
		model: "financial",
		target: `applicant${props.applicant}.financial.hasCurrentAccountSavings`,
		rules: [
			{required: true, message: `An answer is required`},
		]
	}
}
export function paysMaintenance(props) {
	return {
		label: "Pays Maintenance",
		text: capitaliseFirst(props.you.doYou) + " pay maintenance?",
		name: "paysMaintenance",
		answer: {
			type: "choice",
			choices: [
				{
					text: "Yes",
					value: true
				},
				{
					text: "No",
					value: false
				}
			]
		},
		model: "financial",
		target: `applicant${props.applicant}.financial.paysMaintenance`,
	}
}
export function maintenanceCosts(props) {
	return {
		label: "Maintenance Costs",
		text: "How much do " + props.you.you + " pay in maintenance each month?",
		name: "maintenanceCosts",
		answer: {
			type: "euro",
			validation: {
				min: {value: 1, message: "This must be a value greater than €1"},
				max: {value: 10000000, message: "You probably don't need a mortgage"}
			}
		},
		hides: (form) => {
			let costs = form.getFieldValue('paysMaintenance')
			return !costs
		},
		model: "financial",
		target: `applicant${props.applicant}.financial.maintenanceCosts`,
		rules: [
			{required: true, message: `An amount is required`},
		]
	}
}
export function monthlyChildrenAllowance(props){
    return {
        label: "Monthly Children Allowance",
        text: "How much do " + props.you.you + " receive in children's allowance each month?",
        name: "monthlyChildrenAllowance",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        model: "financial",
        target: `applicant${props.applicant}.financial.monthlyChildrenAllowance`,
        rules: [
            {required: true, message: `An amount is required`},
        ]
    }

}
export function monthlyOtherAllowance(props){
    return {
        label: "Monthly Other Allowance",
        text: "How much do " + props.you.you + " receive in other allowances each month?",
        name: "monthlyOtherAllowance",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        model: "financial",
        target: `applicant${props.applicant}.financial.monthlyOtherAllowance`,
        rules: [
            {required: true, message: `An amount is required`},
        ]
    }

}

export const applicantFinancialsSteps = ({mortgage, applicant}) => {
	const betterProps = {
		mortgage,
		applicant,
		you: mortgage[`applicant${applicant}`].strings
	}
	const questions = [
		negativeCredit(betterProps),
		contributeToRelatives(betterProps),
		monthlyAccommodationCosts(betterProps),
		hasChildcareCosts(betterProps),
		monthlyChildcareCosts(betterProps),
		hasSavings(betterProps),
		hasCurrentAccountSavings(betterProps),
		monthlySavings(betterProps),
		paysMaintenance(betterProps),
		maintenanceCosts(betterProps),
        monthlyChildrenAllowance(betterProps),
        monthlyOtherAllowance(betterProps),
	]
	return [{questions}]
}
function ApplicantFinancials(props) {

	const questions = applicantFinancialsSteps(props)[0].questions
	return <SectionForm title="Applicant Financials" key="ApplicantFinancials" {...props} questions={questions}/>
}

export default ApplicantFinancials;